import { keys } from './keys';

export const es = {
  [keys.required]: 'Debe informar el campo',
  [keys.email]: 'La dirección de correo no está bien formada',
  [keys.isTrue]: 'Debe aceptar la política de privacidad',
};
